import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/workspace/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["OrganizationInfobox"] */ "/workspace/src/components/organization-infobox.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Separator"] */ "/workspace/src/components/ui/separator.tsx");
